import { Component } from "@angular/core";
import { of } from "rxjs";
@Component({ selector: ' app-test', template: '<h1> {{ count$ | async }}</h1>'})
export class DemoAppComponent {
    count$ = of(NaN)
}